import { Slider } from "@/components/ui/slider";
import { SliderQuestion as SliderQuestionType } from "./types";
import { QuestionTooltip } from "./QuestionTooltip";
interface SliderQuestionProps {
  question: SliderQuestionType;
  value: number;
  onChange: (questionId: string, value: number) => void;
}
export function SliderQuestion({
  question,
  value,
  onChange
}: SliderQuestionProps) {
  const minValue = question.minValue || 1;
  const maxValue = question.maxValue || 5;
  const step = question.step || 1;
  const defaultValue = question.defaultValue || minValue;
  const currentValue = value !== undefined ? value : defaultValue;
  
  const renderValueLabel = () => {
    // Use stepLabels array if available (maps value to descriptive text)
    if (question.stepLabels && question.stepLabels.length > 0) {
      const index = Math.round((currentValue - minValue) / step);
      if (index >= 0 && index < question.stepLabels.length) {
        return question.stepLabels[index];
      }
    }

    if (question.valueLabel) {
      return `${currentValue}${question.valueLabel}`;
    }
    
    // Special handling for identity attachment question
    if (question.id === "identity-attachment") {
      if (currentValue === 1) return "It's just what I do for work";
      if (currentValue === 2) return "Somewhat connected, but not who I am";
      if (currentValue === 3) return "It's important but doesn't define me";
      if (currentValue === 4) return "A major part of who I am";
      if (currentValue === 5) return "It's central to who I am";
    }
    
    return `${currentValue}`;
  };

  return (
    <div className="space-y-8 w-full max-w-3xl mx-auto py-4">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-3">
          {question.title}
          {question.tooltip && <QuestionTooltip tooltip={question.tooltip} />}
        </h2>
        
        {question.description && <p className="text-muted-foreground">{question.description}</p>}
      </div>
      
      <div className="py-8">
        <Slider 
          defaultValue={[defaultValue]} 
          max={maxValue} 
          min={minValue} 
          step={step} 
          value={[currentValue]} 
          onValueChange={([newValue]) => onChange(question.id, newValue)} 
          className="w-full" 
        />
        
        {question.labels && (
          <div className="flex justify-between mt-3 text-sm text-muted-foreground">
            <span>{question.labels.min}</span>
            <span>{question.labels.max}</span>
          </div>
        )}
        
        <div className="text-center mt-6">
          <span className="font-medium text-primary text-lg">
            {renderValueLabel()}
          </span>
        </div>
      </div>
    </div>
  );
}